import script from "./Top10PodcastsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./Top10PodcastsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./Top10PodcastsCarousel.vue?vue&type=style&index=0&id=c1236678&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1236678"]])

export default __exports__